import { useEffect } from "react";
import useTranslation from "next-translate/useTranslation";

import { Box, Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import Link from "next/link";

export default function AdsCardHorizontal({
  slot,
  format,
  layout,
  h,
  w = "100%",
  p = "0px 16px 16px 16px",
  style = { display: "block", width: "100%", height: "100%" },
}: {
  slot: string;
  format: string;
  layout?: string;
  h?: string;
  w?: string;
  p?: string;
  style?: Record<string, string>;
}) {
  const { t } = useTranslation("common");

  useEffect(() => {
    setTimeout(() => {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  }, []);

  return (
    <Box
      width={w}
      margin="32px auto"
      as="header"
      p={p}
      border={"1px solid #EDF2F7"}
      borderRadius="8px"
    >
      <Flex
        justifyContent="space-between"
        p="0 16px"
        alignItems="center"
        h="17px"
      >
        <Text
          as="p"
          fontWeight="400"
          fontSize="9px"
          lineHeight="16px"
          color="gray.500"
        >
          {t("article.advertising.title")}
        </Text>
        <ChakraLink prefetch={false}
          as={Link}
          href="/contato"
          fontWeight="400"
          fontSize="8px"
          lineHeight="16px"
          color="pink.500"
        >
          {t("article.advertising.button")}
        </ChakraLink>
      </Flex>
      <Box w="100%" maxHeight={h}>
        <ins
          className="adsbygoogle"
          data-ad-client="ca-pub-7086707662719283"
          data-ad-slot={slot}
          style={style}
          data-ad-format={format}
          data-full-width-responsive="true"
          data-ad-layout={layout}
          title="ads"
          aria-label="ads"
        ></ins>
      </Box>
    </Box>
  );
}
